import { useDebounce } from "./component/useDebounce";
import React, { useEffect } from "react";
import Pagination from "./component/Pagination";
import loading from "../images/loader.gif";

const Themes = () => {
  let url = "https://server.launchestore.com/";
  // let url = "https://staggingnode.launchestore.com/";
  const [themeList, setThemelist] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [rowsprpage, setRowsperpage] = React.useState(15);
  const [totalRecord, setTotalPages] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const debouncedSearchText = useDebounce(searchText, 500);
  const [selectStoreType, setSelectStoreType] = React.useState([]);
  const [storeTypeData, setStoreTypeData] = React.useState([]);

  const handleGetAllTheme = React.useCallback(async () => {
    try {
      setLoader(true);
      const response = await fetch(`${url}quick/getAllThemeVal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search: debouncedSearchText,
          page: page,
          sorting: "DESC",
          limit: rowsprpage,
          store_type_id: selectStoreType,
          theme_category_mst_id: [],
        }),
      });

      const data = await response.json();

      if (data.success) {
        setLoader(false);
        setThemelist(data.data);
        setTotalPages(data.totalRecords);
      } else {
        setLoader(false);
      }
    } catch (errors) {
      setLoader(false);
    }
  }, [debouncedSearchText, rowsprpage, page, selectStoreType]);

  const placeholderText = "Search here...";
  const [placeholder, setPlaceholder] = React.useState("");

  React.useEffect(() => {
    handleGetAllTheme();
  }, [handleGetAllTheme]);

  React.useEffect(() => {
    let index = 0;
    let reverse = false;

    const animatePlaceholder = () => {
      setPlaceholder(placeholderText.slice(0, index));

      if (!reverse) {
        index++;
        if (index > placeholderText.length) {
          reverse = true;
          setTimeout(animatePlaceholder, 700); // pause before deleting
          return;
        }
      } else {
        index--;
        if (index < 0) {
          reverse = false;
          index = 0;
        }
      }

      setTimeout(animatePlaceholder, 120);
    };

    animatePlaceholder();
  }, []);

  const handleGetStoreTypeData = React.useCallback(async () => {
    try {
      const response = await fetch(`${url}allStoreType`, {
        method: "GET",
      });

      const data = await response.json();

      console.log({ data });

      if (data.success) {
        const modifyData = data.data.map((data) => ({
          id: data.id.toString(),
          label: data.name,
        }));
        setStoreTypeData(modifyData);
      }
    } catch (errors) {
      console.error(errors);
    }
  }, [url]);

  useEffect(() => {
    handleGetStoreTypeData();
  }, [handleGetStoreTypeData]);

  React.useEffect(() => {
    if (debouncedSearchText) {
      setPage(1);
    }
  }, [debouncedSearchText]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {
        <section className="theme_section_main">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="theme_sec_title">Popular Designs Templates</h2>
                <div className="theme_search_wrp">
                  <input
                    type="text"
                    placeholder={placeholder}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <i className="fa-solid fa-magnifying-glass"></i>
                </div>
              </div>
              <div className="col-12">
                <div className="theme_section_button_wrp">
                  <ul>
                    {/* ALL */}
                    <li className="z-10">
                      <button
                        type="button"
                        className={selectStoreType.length === 0 ? "active" : ""}
                        onClick={() => {
                          setPage(1);
                          setSelectStoreType([]);
                        }}
                      >
                        All
                      </button>
                    </li>

                    {/* DYNAMIC LIST */}
                    {storeTypeData.map((type, index) => (
                      <li>
                        <button
                          className={
                            selectStoreType.some((data) => data === type.id)
                              ? "active"
                              : ""
                          }
                          type="button"
                          onClick={() => {
                            const updatedArray = [...selectStoreType];
                            const findIndex = updatedArray.findIndex(
                              (data) => data === type.id
                            );
                            if (findIndex === -1) {
                              updatedArray.push(type.id);
                            } else {
                              updatedArray.splice(findIndex, 1);
                            }
                            setSelectStoreType(updatedArray);
                            setPage(1);
                          }}
                        >
                          {type.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="theme_selection_wrp">
            <div className="container">
              {!loader && (
                <div className="row">
                  {themeList.map((theme, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                      <div className="theme_selection_inner">
                        <div className="theme_selection_img">
                          <img
                            // width={100}
                            // height={100}
                            src={theme.themeImageUrl}
                            alt="theme"
                          />
                          <div className="theme_selection_btns">
                            <button
                              type="button"
                              onClick={() => {
                                window.location.href = `https://register.launchestore.com?theme_key=${theme.theme_key}`;
                              }}
                            >
                              Continue
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_2787_715)">
                                  <path
                                    d="M12.0991 4.98242L4.98047 12.1011"
                                    stroke="black"
                                    stroke-width="1.0678"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M5.69531 4.98242H12.1021V11.3892"
                                    stroke="black"
                                    stroke-width="1.0678"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2787_715">
                                    <rect
                                      width="17.0847"
                                      height="17.0847"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                window.open(
                                  theme.preview_url,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              }}
                            >
                              Show Live Demo
                            </button>
                          </div>
                        </div>
                        <h3>{theme.name}</h3>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {!loader && themeList.length === 0 && (
                <div className=" d-flex justify-content-center align-items-center">
                  No theme found
                </div>
              )}
              {loader && (
                <div
                  //   initial={{ opacity: 0 }}
                  //   animate={{ opacity: 1 }}
                  className=" d-flex justify-content-center align-items-center product-detail-loader"
                >
                  {/* <svg
                    className="animate-spin h-16 w-16 custome-loader"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 200 200"
                  >
                    <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)">
                      <path
                        fill="currentColor"
                        d="M502,998c-2,12-2,22,0,22s21,7,43,15c41,15,88,13,131-7c41-19,28-50-28-66C584,944,507,963,502,998z"
                      />
                      <path
                        fill="currentColor"
                        d="M735,813c-24-33-128-88-150-79c-9,3-18,13-22,23c-11,29,84,102,148,112c3,1,14-5,25-13C755,842,755,841,735,813z"
                      />
                      <path
                        fill="currentColor"
                        d="M859,731c21-38-27-133-81-162c-16-8-24-7-36,4c-14,14-13,21,3,64c18,47,73,113,94,113C845,750,854,742,859,731z"
                      />
                      <path
                        fill="currentColor"
                        d="M1038,655c16-48,8-115-17-147c-16-19-21-20-34-9c-54,44-40,207,16,199C1019,696,1029,683,1038,655z"
                      />
                      <path
                        fill="currentColor"
                        d="M1209,712c38-40,66-108,55-136c-14-37-75-1-108,66c-29,58-32,78-14,96C1161,757,1170,753,1209,712z"
                      />
                      <path
                        fill="currentColor"
                        d="M1130,1260c-17,32,7,106,50,151c41,43,74,50,90,19c29-53-57-190-119-190C1145,1240,1136,1249,1130,1260z"
                      />
                      <path
                        fill="currentColor"
                        d="M1440,758c0-41-94-26-148,25c-36,33-45,56-31,73c15,18,42,18,82-2C1387,832,1440,780,1440,758z"
                      />
                      <path
                        fill="currentColor"
                        d="M1438,1268c21-21,13-53-20-86c-99-95-235-72-153,26C1312,1263,1409,1297,1438,1268z"
                      />
                      <path
                        fill="currentColor"
                        d="M1505,1000c0-20-62-50-105-50s-105,30-105,50s62,50,105,50c19,0,51-8,70-18C1489,1023,1505,1008,1505,1000z"
                      />
                    </g>
                  </svg> */}
                  <img
                    src={loading}
                    // height={200}
                    // width={200}
                    alt=""
                    // quality={90}
                    className="animate-spin custome-loader"
                  ></img>
                </div>
              )}
              {!loader && totalRecord > themeList.length && (
                <div className="pagination-part">
                  <Pagination
                    itemsLength={themeList.length}
                    itemsPerPage={rowsprpage}
                    totalItems={totalRecord}
                    onPageChange={handleChangePage}
                    currentPage={page}
                    setRowsPerPage={setRowsperpage}
                    setPage={setPage}
                    rowsPrPageList={[9, 15, 30, 45, 100]}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      }

      {/* {themeList.length < totalRecord && (
        <div className=' d-flex justify-content-center align-items-center'>
          <button
            className='px-2 py-2 rounded bg-black text-white'
            onClick={() => {
              setRowsperpage(rowsprpage + 50)
            }}
            disabled={loader}
          >
            Load More
          </button>
        </div>
      )} */}

      {/* </div> */}
    </>
  );
};

export default Themes;
